import { NgModule, inject } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
// import { LoginComponent } from './components/login/login.component';
// import { RegistrazioneComponent } from './components/registrazione/registrazione.component';

import { ProductsListComponent } from './components/products-list/products-list.component';
import { UserDataComponent } from './components/user-data/user-data.component';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs';
import { PreSurveyComponent } from './pages/survey/pre-survey/pre-survey.component';

export const isAuthenticated = () => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        // router.navigate(['']);

        return false;
      }
      return true;
    })
  );
};

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), 
    data: {
        title: "Confronto Polizze Vita | Scegli l'Assicurazione Migliore per te",
        description: "Confronta le migliori assicurazioni sulla vita per scegliere la polizza che fa per te. Scopri premi, coperture e condizioni in un unico luogo per trovare l'offerta ideale!"
    } },
  
  { path: 'DirectSearch', loadChildren: () => import('./pages/direct-search/direct-search.module').then(m => m.DirectSearchModule) },
  { path: 'directsearch', loadChildren: () => import('./pages/direct-search/direct-search.module').then(m => m.DirectSearchModule) },


  { path: 'PreSurvey', component: PreSurveyComponent },
  { path: 'Survey', loadChildren: () => import('./pages/survey/survey.module').then(m => m.SurveyModule) },
  { path: 'survey', loadChildren: () => import('./pages/survey/survey.module').then(m => m.SurveyModule) },


  { path: 'policy', loadChildren: () => import('./pages/policy-detail/policy-detail.module').then(m => m.PolicyDetailModule) },
  { path: 'ProductsList', component: ProductsListComponent },
  { path : 'Area_Personale', component: UserDataComponent,canActivate: [isAuthenticated], data: { title: 'user info' }},

  { path: 'Glossario', loadChildren: () => import('./pages/glossary/glossary.module').then(m => m.GlossaryModule ) },
  { path: 'glossario', loadChildren: () => import('./pages/glossary/glossary.module').then(m => m.GlossaryModule ) },

  { path: 'informative', loadChildren: () => import('./pages/informative/informative.module').then(m => m.InformativeModule) },

  { path: '**', loadChildren: () => import('./pages/page-not-found/page-not-found.component.module').then(m => m.PageNotFoundModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
